import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.5 12.5V11.5C3.5 9.84315 4.84315 8.5 6.5 8.5H12.5C14.1569 8.5 15.5 9.84315 15.5 11.5V12.5M3.5 12.5V17.5C3.5 19.1569 4.84315 20.5 6.5 20.5H12.5C14.1569 20.5 15.5 19.1569 15.5 17.5V12.5M3.5 12.5H15.5M8.5 6.5V6.5C8.5 4.84315 9.84315 3.5 11.5 3.5H17.5C19.1569 3.5 20.5 4.84315 20.5 6.5V12.5C20.5 14.1569 19.1569 15.5 17.5 15.5V15.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
